import axios from "axios"

const paramsSerializer = (params) => {
    const Qs = require("qs")
    return Qs.stringify(params, { encode: false })
}

export const getInfoHSM = (headers, data) => {
    return axios.put(
        `${process.env.REACT_APP_MANAGEMENT_API_URL}/certificate/info-hsm`,
        data,
        {
            headers
        },
        { useCache: false }
    )
}

export const addCertificatePerson = (headers, id, data) => {
    return axios.post(
        `${process.env.REACT_APP_MANAGEMENT_API_URL}/certificate/${id}/person/upload`,
        data,
        {
            headers
        }
    )
}

export const addCertificateOrg = (headers, id, data) => {
    return axios.post(
        `${process.env.REACT_APP_MANAGEMENT_API_URL}/certificate/${id}/organization/upload`,
        data,
        {
            headers
        }
    )
}

export const getChungThuSo = (params) => {
    return axios.get(
        `http://localhost:6703/api/cybertax/getcert`,
        {
            params,
            paramsSerializer
        },
        { useCache: false }
    )
}

export const getCertificatesPerson = (headers, id) => {
    return axios.get(
        `${process.env.REACT_APP_MANAGEMENT_API_URL}/certificate/${id}/person`,
        {
            headers
        }
    )
}  
  
export const getCertificatesOrg = (headers, id) => {
    return axios.get(
        `${process.env.REACT_APP_MANAGEMENT_API_URL}/certificate/${id}/organization`,
        {
            headers
        }
    )
}

export const deleteCertificates = (headers, id) => {
    return axios.delete(
        `${process.env.REACT_APP_MANAGEMENT_API_URL}/certificate/${id}`,
        {
            headers
        }
    )
}

export const addCertificatePersonIframe = (headers, id, appId, messageId, data) => {
    return axios.put(
        `${process.env.REACT_APP_MANAGEMENT_API_URL}/integrated/person/${id}/add-certificate-iframe/${appId}/${messageId}`,
        data,
        {
            headers
        },
        { useCache: false }
    )
}

export const addCertificateOrgIframe = (headers, id, appId, messageId, data) => {
    return axios.put(
        `${process.env.REACT_APP_MANAGEMENT_API_URL}/integrated/organization/${id}/add-certificate-iframe/${appId}/${messageId}`,
        data,
        {
            headers
        },
        { useCache: false }
    )
}
